import { memo } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { damping: 30, stiffness: 200 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[2px] bg-[#F47B20] z-[60] origin-left"
      style={{ scaleX }}
    />
  );
}

export default memo(ScrollProgress);
